import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { APP_NAME, APP_VERSION, APP_WEBSITE_URL, COPYRIGHT_TEXT } from '@app/shared/utilities/app-info';

/**
 * Split-screen shell shared by every public auth page:
 * branded aside on the left, projected form card on the right.
 * Styles live in src/assets/scss/_auth.scss so projected content can use them.
 */
@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="auth">
      <aside class="auth__side">
        <div class="auth__side-top">
          <a class="auth__logo" [href]="websiteUrl" [title]="appName + ' website'">
            <img src="assets/images/auth/logo.png" [alt]="appName" />
          </a>
          <span class="auth__pill" *ngIf="pill">{{ pill }}</span>
        </div>

        <div class="auth__side-body">
          <h2>{{ heading }}</h2>
          <ul class="check-list" *ngIf="bullets?.length">
            <li *ngFor="let bullet of bullets">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="m9 12 2 2 4-4"></path>
              </svg>
              <p>{{ bullet }}</p>
            </li>
          </ul>
          <img class="auth__side-img" src="assets/images/auth/hero-img.png" alt="" aria-hidden="true" />
        </div>

        <p class="auth__foot">{{ copyright }}</p>
      </aside>

      <main class="auth__main">
        <div class="auth__top">
          <a class="auth__brand-sm" [href]="websiteUrl" [title]="appName + ' website'">
            <img src="assets/images/auth/logo.png" [alt]="appName" />
          </a>
        </div>

        <div class="auth__card">
          <ng-content></ng-content>
        </div>

        <div class="auth__bottom">
          <span class="auth__foot auth__foot--sm">{{ copyright }}</span>
          <span class="build-version">v{{ version }}</span>
        </div>
      </main>
    </div>
  `
})
export class AuthLayoutComponent {
  /** Large headline in the branded aside. */
  @Input({ required: true }) heading = '';
  /** Short benefit statements rendered as a check list. */
  @Input() bullets: string[] = [];
  /** Small uppercase badge under the logo. */
  @Input() pill = APP_NAME;

  readonly appName = APP_NAME;
  readonly version = APP_VERSION;
  readonly websiteUrl = APP_WEBSITE_URL;
  readonly copyright = COPYRIGHT_TEXT;
}
